module.exports = __webpack_public_path__ + "static/img/HotSend2.447d9ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HotSend2.png
// module id = qBhm
// module chunks = 0